export default __webpack_public_path__ + "static/media/logo.6cbe9b6b.svg";